// extracted by mini-css-extract-plugin
export default {"userProfileTitle":"Title_userProfileTitle__W791f"};